
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 63 63","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 31.5C0 14.103 14.103 0 31.5 0S63 14.103 63 31.5 48.897 63 31.5 63 0 48.897 0 31.5z","fill":"#1BBAC8"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.733 14.084c0-.123 0-.246.06-.368.183-.492.731-.737 1.219-.614.487.122 1.157.306 2.01.49.914.246 2.498.86 4.69 1.842 2.194 1.044 4.204 2.272 5.91 3.684 1.767 1.411 3.35 3.499 4.752 6.2 1.279 2.394 2.01 5.095 2.132 7.98h6.213c.427 0 .792.245.975.614.061.123.061.307.061.43 0 .245-.06.49-.244.675L32.536 49.443c-.183.245-.488.368-.792.368-.305 0-.61-.123-.792-.368L18.829 34.955c-.122-.184-.244-.43-.244-.675 0-.123.061-.307.122-.43.183-.368.548-.613.914-.613h7.25c-.062-4.666-.61-8.35-1.645-10.989-1.036-2.762-3.412-5.156-7.006-7.305-.305-.123-.487-.49-.487-.86z","fill":"#fff"}})])
          )
        }
      }
    